'use client';

import Script from 'next/script';

interface MyComponentProps {
  trackingId: string;
}

export default function GAScript({ trackingId }: MyComponentProps) {
  return (
    <>
      {/* Google tag (gtag.js) */}
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`}></Script>
      <Script id="google-analytics-script">
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('set', 'user_properties', { 'user_role': 'Family' });
          gtag('config', '${trackingId}');
        `}
      </Script>
    </>
  );
}
